<script lang="ts" setup>
import { usePageStore } from '@toni/rendering/src/stores/page'
import { Avatar as AvatarRoot, AvatarImage, type AvatarProps } from '@toni/brand-ui'

withDefaults(
  defineProps<{
    imgSrc?: string,
    alt?: string,
    size?: AvatarProps['size']
  }>(),
  {
    imgSrc: undefined,
    alt: '',
    size: 'xl'
  }
)

const brand = usePageStore().brandFromStore as string

const fallbackImageSrc = '/assets/images/todaysgolfer/childtags-fallback.jpg'
</script>

<template>
  <AvatarRoot :size="size">
    <AvatarImage v-if="imgSrc"
                 :src="imgSrc"
                 :alt="alt" />
    <AvatarImage v-else
                 :src="fallbackImageSrc"
                 :alt="brand" />
  </AvatarRoot>
</template>
